import { Tween } from "@westpierstudio/luma/createjs";
import { GameServices } from "game/GameServices";
import { Emitter } from "pixi-particles";
import { Container } from "pixi.js";
import { ReelsLayout } from "../reels/ReelsModel";
import { JackpotSpec } from "./Jackpot";

export class JackpotParticle extends Container {
    emitter: Emitter;

    constructor(protected readonly services: GameServices, protected readonly spec: JackpotSpec, protected readonly reelSpec: ReelsLayout, protected readonly delayed: boolean = false) {
        super();
        const { factory } = services;
        this.emitter = factory.createParticleEmitter(spec.particleTrail, this);
        this.position.x += spec.particleOffset.x;
        this.position.y += spec.particleOffset.y;
        this.stopParticles();
    }

    startParticles() {
        const mult = this.delayed ? -1 : 1;
        const { symbolSize, symbolCount } = this.reelSpec;
        const height = symbolSize.height * symbolCount / 2;
        const width = symbolSize.width / 2;
        this.emitter.spawnCircle.x = mult * width;
        this.emitter.spawnCircle.y = mult * -height;
        const tween = Tween.get(this.emitter.spawnCircle)
            .to({ x: mult * -width }, 240)
            .to({ y: mult * height }, 500)
            .to({ x: mult * width }, 240)
            .to({ y: mult * -height }, 500);
        tween.loop = -1;
        this.emitter.emit = true;
        this.visible = true;
    }

    stopParticles() {
        Tween.removeTweens(this.emitter.spawnCircle);
        this.visible = false;
        this.emitter.emit = false;
    }
}
